// Port of api/fuel/app/classes/filter/search/games/rules/query/version_worth.php
import Rule from 'offline/filter/core/search/rule'

export default Rule.create({
	name: 'version_worth',
	field: function() { return 'v.game_version_worth_value' }
})
